export default "__VITE_ASSET__bc9f1980__"